import * as is from "./is";

const parse = require("url-parse");

export function trim(str) {
  return str.replace(/^\s*/, "").replace(/\s*$/, "");
}

export function toString(val) {
  if (val === null) {
    return "";
  }
  return typeof val === "object" ? JSON.stringify(val, null, 2) : String(val);
}

export function toNumber(val) {
  const n = parseFloat(val);
  return isNaN(n) ? val : n;
}

export function makeMap(str, expectsLowerCase) {
  const map = Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i += 1) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => map[val.toLowerCase()] : (val) => map[val];
}

export function remove(arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
  return arr;
}

// eslint-disable-next-line
const hasOwnProperty = Object.prototype.hasOwnProperty;

export function hasOwn(obj, key) {
  return !is.isUndef(obj) && hasOwnProperty.call(obj, key);
}

export function toArray(list, start) {
  const startIndex = start || 0;
  let i = list.length - startIndex;
  const ret = new Array(i);
  while (i > 0) {
    ret[i] = list[i + startIndex];
    i -= 1;
  }
  return ret;
}

export function generateRandomString(size) {
  const charArr = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  let result = "";
  for (let i = 0; i < size; i += 1) {
    result += charArr[Math.floor(Math.random() * charArr.length)];
  }
  return result;
}

export function objToQuery(obj) {
  let queryStr = "?";
  for (let i = 0; i < Object.keys(obj).length; i += 1) {
    if (is.isArray(obj[Object.keys(obj)[i]])) {
      for (let j = 0; j < obj[Object.keys(obj)[i]].length; j += 1) {
        // eslint-disable-next-line
        queryStr += `${Object.keys(obj)[i]}[]=${encodeURIComponent(obj[Object.keys(obj)[i]])}${(i === Object.keys(obj).length - 1 && j === obj[Object.keys(obj)[i]].length - 1) ? '' : '&'}`;
      }
    } else {
      queryStr += `${Object.keys(obj)[i]}=${encodeURIComponent(
        obj[Object.keys(obj)[i]]
      )}${i === Object.keys(obj).length - 1 ? "" : "&"}`;
    }
  }
  return queryStr;
}

export function startWith(str, test) {
  return new RegExp(`^${test}`).test(str);
}

export function endWith(str, test) {
  return new RegExp(`${test}$`).test(str);
}

export function getQueryValue(key) {
  if (!location.search && !location.hash) {
    return null;
  }
  let queryString = location.search || location.hash;
  queryString = queryString.substring(queryString.lastIndexOf("?") + 1);
  const find = queryString.split("&").find((ele) => {
    const queryKey = ele.split("=")[0];
    if (queryKey === key) {
      return true;
    } else {
      return false;
    }
  });
  if (find) {
    return find.split("=")[1];
  } else {
    return null;
  }
}

export function getDomain(lang) {
  const langDomainMappings = {
    pt: ".com.br",
    en: ".com",
    zh: ".cn",
    tr: "-tr.com",
    no: "-no.com",
    cs: ".cz",
    da: ".dk",
    ja: ".jp",
    sv: ".se",
    el: ".gr",
  };

  const otherDomains = "fr de it nl es fi pl tw hu".split(" ");

  if (!langDomainMappings[lang] && !otherDomains.includes(lang)) {
    lang = "en";
  }

  const dotcom = langDomainMappings[lang] || `.${lang}`;

  return `https://www.apowersoft${dotcom}`;
}

// 根据identity_token最后一位判断登录来源
// * 1 手机验证码
// * 2 手机密码
// * 3 邮箱验证码
// * 4 邮箱密码
// * 5 qq
// * 6 weibo
// * 7 微信
// * 8 微信服务号
// * 9 钉钉
// * a google
// * b facebook
// * c twitter
export function getAccountPreByIdentityToken(identityToken) {
  if (!identityToken) {
    return "";
  }
  let accountPre;
  switch (identityToken[identityToken.length - 1]) {
    case "1":
    case "2":
    case "3":
    case "4":
      accountPre = "";
      break;
    case "5":
      accountPre = "QQ-";
      break;
    case "6":
      accountPre = "Weibo-";
      break;
    case "7":
      accountPre = "WeChat-";
      break;
    case "8":
      accountPre = "WeChatS-";
      break;
    case "9":
      accountPre = "DingTalk-";
      break;
    case "a":
      accountPre = "Google-";
      break;
    case "b":
      accountPre = "Facebook-";
      break;
    case "c":
      accountPre = "Twitter";
      break;
    default:
      accountPre = "";
  }
  return accountPre;
}

export function addToken(url, identityToken) {
  const parsedUrl = parse(url, true);
  parsedUrl.set(
    "query",
    Object.assign(parsedUrl.query, { identity_token: identityToken })
  );
  return parsedUrl;
}

export function getApowersoftDomain(lang) {
  const langDomainMappings = {
    pt: ".com.br",
    en: ".com",
    zh: ".cn",
    tr: "-tr.com",
    no: "-no.com",
    cs: ".cz",
    da: ".dk",
    ja: ".jp",
    sv: ".se",
    el: ".gr",
  };

  const otherDomains = "fr de it nl es fi pl tw hu".split(" ");
  if (!langDomainMappings[lang] && !otherDomains.includes(lang)) {
    lang = "en";
  }

  return "https://www.apowersoft" + (langDomainMappings[lang] || "." + lang);
}

export function includeOurDomain() {
  let flag = false;
  // 是否是我们的管理的域名
  const isApowerDomain = location.host.includes("apowersoft");

  if (isApowerDomain) {
    return isApowerDomain;
  }
  const arr = [
    "airmore",
    "showmore.com",
    "videograbber.net",
    "screenshot.net",
    "lightpdf.com",
    "lightmake.com",
    "reccloud",
  ];
  for (let i = 0; i < arr.length; i++) {
    if (location.hostname.indexOf(arr[i]) != -1) {
      flag = true;
      break;
    }
  }
  return flag;
}

export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}
